import { initializeApp } from 'firebase/app'
import firebaseConfig from './firebaseConfig'

const app = initializeApp(firebaseConfig, {
  automaticDataCollectionEnabled: false,
})

export default app
